/**
 * Event name for a chat message.
 * @constant {string}
 */
const messageEvent = 'chat:message';

/**
 * Event name for typing in chat.
 * @constant {string}
 */
const typingEvent = 'chat:typing';

/**
 * Event name for when a conversation is created.
 * @constant {string}
 */
const conversationCreatedEvent = 'chat:conversationCreated';

/**
 * Event name for when a conversation is removed.
 * @constant {string}
 */
const conversationRemovedEvent = 'chat:conversationRemoved';

/**
 * Event name for when a proposal is cancelled.
 * @constant {string}
 */
const proposalCancelledEvent = 'chat:proposalCancelled';

/**
 * Event name for when a proposal is invalidated.
 * @constant {string}
 */
const proposalInvalidatedEvent = 'chat:proposalInvalidated';

export {
  typingEvent,
  messageEvent,
  proposalCancelledEvent,
  conversationRemovedEvent,
  proposalInvalidatedEvent,
  conversationCreatedEvent,
};
